import React from "react";

export default function PlaceAdminHome() {
  return <div>PlaceAdminHome</div>;
}
